var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeopleHighlight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {
    display: "block"
  }
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#DCFF00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.875
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 21a5 5 0 0 0-10 0M22 10.5a3.5 3.5 0 0 0-5.507-2.868M7.507 7.632A3.5 3.5 0 0 0 2 10.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0M21 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M8 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
}))));
export default SvgPeopleHighlight;